import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class EditShoppingCarService {

  constructor(
    private _httpService:  HttpService
  ) { }

  // Objetos Observable y Emiters
  private productIdSubjet$ = new Subject<number>();

  emmiterProductId( productId: number ): void {
    this.productIdSubjet$.next(productId);
  }

  getSubjetProductIdSelected(): Subject<number> {
    return this.productIdSubjet$;
  }

  // Funciones HTTP
  getItemsShoppingCar(productId: string) {
    let headers = {
      'dataAdditions': 'true'
    }
    return this._httpService.httpGet(`compras/item/${productId}`, headers);
  }
  
  updateShoppingCar(data: any) {
    return this._httpService.httpPatch(`compras/item/${data.id}`, data);
  }

}
